import React from 'react';
import { asJSON } from './js/util';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import './App.css';
import * as config from './config';
import {loadExamples, setupExample} from './js/init';
import {CodeCol, VisCol, RecomModal, ExampleSelect, KeyframeModal, AnimViewModal, SequenceCol} from './components'
import {optToParam,
  updateRecomParameters,
  showRecom, onRecomHide} from './js/recomControl'
import {showKeyframeModal, onKeyframeModalHide, onKeyframeRecomParamChange, isKeyframeRecommendable} from './components/KeyframeModal/keyframeRecomControl'
import * as stringify from "json-stringify-pretty-compact";

import {
  Container,
  Row,
  Col,
  Button
} from 'react-bootstrap'
import ReactGA from 'react-ga';
import InfoModal from './components/InfoModal';

ReactGA.initialize('UA-179938201-1');
ReactGA.pageview(window.location.pathname + window.location.search);

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      animViewModal: { sSpec: {}, eSpec: {}, gemSpec: {} },
      animViewModalShow: false,

      sVisEditor: undefined,
      eVisEditor: undefined,
      editor: undefined,

      currExample: undefined,
      selectedSpecIndex: 0,
      examples: [],

      recomModalShow: false,
      recoms: [],
      recomParameters: {
        duration: 2000,
        dataJoinKey: "",
        stageN: 2,
        xScaleDomainDimension: "default",
        yScaleDomainDimension: "default"
      },
      recom: { sSpec: {}, eSpec: {} },

      sequence: [{}, {}], //Vega-Lite Charts
      animationSpecs: [{}],
      currAnimId: undefined,

      keyframeModal: { sSpec: {}, eSpec: {}, recoms: {},
        params: {
          duration: 2000,
          dataJoinKey: "",
          stageN: 1,
          xScaleDomainDimension: "default",
          yScaleDomainDimension: "default"
        },
      },
      keyframeRecommendable: false,
      keyframeModalShow: false,
      ...config.default,

      infoModalShow: false
    }
  }


  render() {

    return <div>
      <RecomModal
        modalShow={this.state.recomModalShow}
        onHide={onRecomHide.bind(this)}
        recomParameters={this.state.recomParameters}
        recoms={this.state.recoms}
        sSpec={this.state.recom.sSpec}
        eSpec={this.state.recom.eSpec}
        updateRecomParameters={updateRecomParameters.bind(this)}
        setValueOnEditor={this.setValueOnEditor.bind(this)}
      />
      <AnimViewModal
        modalShow={this.state.animViewModalShow}
        animationSpecs={this.state.animationSpecs}
        sequence={this.state.sequence}
        onHide={this.onAnimViewModalHide.bind(this)}
      />
      <KeyframeModal
        modalShow={this.state.keyframeModalShow}

        onHide={onKeyframeModalHide.bind(this)}
        onChangeSequence={this.onChangeSequence.bind(this)}
        onKeyframeRecomParamChange={onKeyframeRecomParamChange.bind(this)}
        keyframeModal={this.state.keyframeModal}
      />
      <InfoModal
        modalShow={this.state.infoModalShow}
        onHide={this.onInfoModalHide.bind(this)}
      />

      <Container fluid>
      <Row className="mt-1 pb-1 border-bottom">
        <Col>
          <span >Example : </span>
          <ExampleSelect
            examples={this.state.examples}
            setupExample = {this.setupExampleSequence.bind(this)}
            editor={this.state.editor}
            sVisEditor={this.state.sVisEditor}
            eVisEditor={this.state.eVisEditor}
            recomParameters={this.state.recomParameters}
          />
          <Button
            className="float-right"
            size="sm"
            onClick={(event) => {this.setState({infoModalShow: true})}}
          ><Icon icon={faInfoCircle}></Icon> About
          </Button>
        </Col>
      </Row>

        <Row id="main">
          <SequenceCol
            animationSpecs={this.state.animationSpecs}
            sequence={this.state.sequence}
            currAnimId={this.state.currAnimId}
            onChangeCurrAnimId={this.onChangeCurrAnimId.bind(this)}
            onChangeSequence={this.onChangeSequence.bind(this)}
            showKeyframeModal={showKeyframeModal.bind(this)}
            keyframeRecommendable={this.state.keyframeRecommendable}
          />

          <VisCol
            animationSpecs={this.state.animationSpecs}
            sequence={this.state.sequence}
            currAnimId={this.state.currAnimId}
            onChangeCurrAnimId={this.onChangeCurrAnimId.bind(this)}
            onChangeSequence={this.onChangeSequence.bind(this)}
            showAnimViewModal={this.showAnimViewModal.bind(this)}
            showKeyframeModal={showKeyframeModal.bind(this)}
          />
          <CodeCol
            attachEditorRefs={this.attachEditorRefs.bind(this)}
            sSpecText={this.state.sSpecText}
            eSpecText={this.state.eSpecText}
            gemSpecText={this.state.gemSpecText}
            onSpecChange={this.onSpecChange.bind(this)}
            showRecomModal={showRecom.bind(this)}
            onRecomHide={onRecomHide.bind(this)}
          />
        </Row>
      </Container>
    </div>
  }

  async componentDidMount() {
    let loadedExamples = await loadExamples(this.state.exampleList)


    window.addEventListener("message", (event) => {
      const whitelist = [
        "http://localhost",
        "yhoonkim.github.io",
        "uwdata.github.io",
        "vega.github.io"
      ]
      // The below is for the anonymized supplement material.
      // const whitelist = [
      //   "http://localhost",
      // ]


      if (whitelist.find(origin => event.origin.indexOf(origin)>=0) && (typeof(event.data) === "string")) {
        let parsed = asJSON(event.data);
        if (parsed && parsed.sSpec && parsed.eSpec) {
          window.opener.postMessage("ack", "*");
          setupExample.bind(this)(parsed, this.state.editor, this.state.sVisEditor, this.state.eVisEditor);
        }
      }

    })



    //take the hash and find if there is a corresponding example.
    let hashString = window.location.hash.substring(1);
    let foundExample = loadedExamples.find(eg => eg.value === hashString + ".json")
    if (foundExample) {
      setupExample.bind(this)(foundExample, this.state.editor, this.state.sVisEditor, this.state.eVisEditor);
    }
    if (loadedExamples && (this.state.defaultExample !== undefined)){
      this.setupExampleSequence(loadedExamples[this.state.defaultExample])
    }
    this.setState({examples: loadedExamples});

  }


  setupExampleSequence(example) {

    this.setState({
      sequence: example.sequence,
      animationSpecs: example.gemSpecs || example.geminiSpecs || example.animSpecs || example.animationSpecs,
      currAnimId: undefined,
      sSpecText: "",
      eSpecText: "",
      gemSpecText: "",
      keyframeModal: {
        ...this.state.keyframeModal,
        params: {
          ...this.state.keyframeModal.params,
          ...optToParam(example.opt)
        }
      },
      keyframeRecommendable: isKeyframeRecommendable(example.sequence)
    })
  }

  onChangeCurrAnimId(id) {

    let sSpec = this.state.sequence[id],
      eSpec = this.state.sequence[id+1],
      gemSpec = this.state.animationSpecs[id];

    let newState = {
      currAnimId: id,
      sSpecText: sSpec ? stringify(sSpec) : "",
      eSpecText: eSpec ? stringify(eSpec) : "",
      gemSpecText: gemSpec ? stringify(gemSpec) : ""
    }

    this.setState(newState)


  }

  async onChangeSequence(newSequence, newAnimationSpecs) {
    if ((newSequence.length <= 1) || (newAnimationSpecs.length <= 0)) {
      await this.setState({
        sequence: [{}, {}],
        animationSpecs: [{}],
        currAnimId: undefined,
        sSpecText: "",
        eSpecText: "",
        gemSpecText: "",
        keyframeRecommendable: false
      })
    } else {
      let keyframeRecomParam = this.state.keyframeModal.params || {};

      let inheritedRecommParams = {
        ...keyframeRecomParam,
        stageN: 1,
        duration: keyframeRecomParam.duration / (keyframeRecomParam.stageN)
      }

      let recommendable = isKeyframeRecommendable(newSequence);

      await this.setState({
        sequence: newSequence,
        animationSpecs: newAnimationSpecs,
        recomParameters: inheritedRecommParams,
        currAnimId: undefined,
        sSpecText: "",
        eSpecText: "",
        gemSpecText: "",
        keyframeRecommendable: recommendable
      })
    }
  }

  onSpecChange(specType, newSpecText) {
    let newSpecState = {};
    if (newSpecText !== this.state[specType+"Text"]) {
      newSpecState[specType+"Text"] = newSpecText;
    }
    if (specType === "sSpec") {
      newSpecState.sequence = [...this.state.sequence];
      newSpecState.sequence[this.state.currAnimId] = asJSON(newSpecText) || {}
    } else if (specType === "eSpec") {
      newSpecState.sequence = [...this.state.sequence];
      newSpecState.sequence[this.state.currAnimId+1] = asJSON(newSpecText) || {}
    } else if (specType==="gemSpec") {
      newSpecState.animationSpecs = [...this.state.animationSpecs];
      newSpecState.animationSpecs[this.state.currAnimId] = asJSON(newSpecText) || {}
    }

    this.setState(newSpecState);
  }


  async showAnimViewModal() {

    this.setState({ animViewModalShow: true });

  }
  onAnimViewModalHide() {
    this.setState({ animViewModalShow: false });
  }

  onInfoModalHide() {
    this.setState({ infoModalShow: false });
  }



  attachEditorRefs(ref) {
    this.setState(ref);
  }
  setValueOnEditor(str){
    if (this.state.editor) {
      this.state.editor.setValue(str)
    }
  }

}

export default App;
